import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
    AuthenticationTask,
    PageOfAuthenticationTasks,
    AuthenticationTaskSignabilityRequest,
    PageOfUserLimits,
    UserLimit,
    UserLimitPatch
} from './authenticatiebeheer.model';

@Injectable({ providedIn: 'root' })
export class AuthenticatiebeheerResource {
    private readonly httpClient = inject(HttpClient);

    private readonly baseUrl: string = '/services/apic-authenticatiebeheer/api';

    public deleteUserLimit(limitId: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.baseUrl}/user-limits/${limitId}`);
    }

    public getAuthenticationTask(operationId: string): Observable<AuthenticationTask> {
        return this.httpClient.get<AuthenticationTask>(`${this.baseUrl}/authentication-tasks/${operationId}`);
    }

    public getAuthenticationTasks(): Observable<PageOfAuthenticationTasks> {
        return this.httpClient.get<PageOfAuthenticationTasks>(`${this.baseUrl}/authentication-tasks`);
    }

    public getUserLimit(limitId: string): Observable<UserLimit> {
        return this.httpClient.get<UserLimit>(`${this.baseUrl}/user-limits/${limitId}`);
    }

    public getUserLimits(): Observable<PageOfUserLimits> {
        return this.httpClient.get<PageOfUserLimits>(`${this.baseUrl}/user-limits`);
    }

    public postAuthenticationTaskSignability(authenticationTaskSignabilityRequest: AuthenticationTaskSignabilityRequest): Observable<void> {
        return this.httpClient.post<void>(`${this.baseUrl}/authentication-task-signability`, authenticationTaskSignabilityRequest);
    }

    public postUserLimits(userLimits: UserLimit[]): Observable<void> {
        return this.httpClient.post<void>(`${this.baseUrl}/user-limits`, userLimits);
    }

    public updateUserLimits(limitId: string, userLimitPatch: UserLimitPatch): Observable<void> {
        return this.httpClient.patch<void>(`${this.baseUrl}/user-limits/${limitId}`, userLimitPatch);
    }
}
